/**
 * created by xcc on 2021/11/4
 * 新媒体批量新增组件
 */
import React from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    Icon,
    Table,
    Form,
    Input,
    Select,
    Button,
    Divider,
    Menu,
    Upload,
    Dropdown,
        Popconfirm
} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import Scrollbars from "react-custom-scrollbars";
import ButtonGroup from "antd/es/button/button-group";
import {uuid} from "../../../../utils";
import {
    getExcelTemplate,
    saveExcelTemplate,
    deleteData,
    checkName, checkDouyinLink
} from "../../actions/newMediaManage";
import NewAddMedia from "./NewAddMedia";
import BaseComponent from "../../../../base/BaseComponent";
import $ from "jquery";
import {getNewMediaFields} from "../../actions/platformMaintenance";

const {Option} = Select;
const requiredMark = () => {
    return <span style={{color: "red", marginRight: 3}}>*</span>
};
export default class BatchAdd extends BaseComponent {
    static defaultProps = {}
    static propTypes = {
        title: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataSource: [],
            currentMedia: {}, //当前编辑媒体账号数据
            name: "",
            path: "",
            size: 0,
            suffix: "",
            uploadTime: null,
            uploadUserName: "",
            batchAddButtons: [],
            simpleAddOrEdit: false,
            douYinVisible: false,
            douYinLink: "",
            verifyParams: {},
            saveAfterExit: false,
            link: ""
        };
        this.batchAddColumns = [
            {
                title: <>{requiredMark()}媒体名称</>,
                key: "name",
                ellipsis: true,
                width: 230,
                render: (record) => {
                    let type = record.newMediaTypeName === "公众号" || record.newMediaTypeName === "微博" || record.newMediaTypeName === "抖音";
                    return (
                        <div style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                            <Input style={{width: (type && record.newMediaTypeName !== "抖音") ? "80%" : "100%", background: "#F6F8FD"}}
                                   value={record.name}
                                   onChange={(e) => {
                                       record.name = e.target.value;
                                       this.setState({})
                                   }}/>
                            {type ? <div>
                                {
                                    record.newMediaTypeName === "抖音" ?
                                        // <Button onClick={() => {
                                        //     this.setState({
                                        //         link: record.link,
                                        //         douYinVisible: true,
                                        //         verifyParams: record,
                                        //     })
                                        // }} style={{background: "#F6F8FD"}}>验证</Button>
                                        null
                                        :
                                        <Button onClick={() => this.verifyName(record)}
                                                style={{background: "#F6F8FD"}}>验证</Button>
                                }
                            </div> : null}
                        </div>
                    )
                }
            },
            {
                title: <>{requiredMark()}媒体平台</>,
                key: "mediaPlat",
                width: 100,
                ellipsis: true,
                render: (record) => {
                    return (
                        <div>
                            {record.newMediaTypeName}
                            {/*<Select className={'mediaListContent'}*/}
                            {/*        placeholder={"媒体平台"}*/}
                            {/*        value={record.newMediaTypeId}*/}
                            {/*        style={{width: '100%'}}*/}
                            {/*        onChange={(e) => {*/}
                            {/*            record.newMediaTypeId = e;*/}
                            {/*            this.setState({})*/}
                            {/*        }}>*/}
                            {/*    {this.props.mediaPlatform && this.props.mediaPlatform.length > 0 && this.props.mediaPlatform.map(item => {*/}
                            {/*        return (*/}
                            {/*            <Option key={item.id}*/}
                            {/*                    value={item.id}>*/}
                            {/*                <span style={{*/}
                            {/*                    verticalAlign: "middle",*/}
                            {/*                    marginRight: "5px"*/}
                            {/*                }}>{item.name}</span>*/}
                            {/*                <img src={item.logoPath} alt=""*/}
                            {/*                     style={{*/}
                            {/*                         width: 18,*/}
                            {/*                         height: 18,*/}
                            {/*                         borderRadius: "50%",*/}
                            {/*                         objectFit: "cover"*/}
                            {/*                     }}/>*/}
                            {/*            </Option>*/}
                            {/*        )*/}
                            {/*    })}*/}
                            {/*</Select>*/}
                        </div>
                    )
                }
            },
            {
                title: "媒体LOGO",
                key: 'mediaLogo',
                width: 100,
                align: 'center',
                render: (record => {
                    const uploadButton = (
                        <div key={uuid()}>
                            <Icon type={record.checked ? 'loading' : 'plus'}/>
                        </div>
                    );
                    return (
                        <div id={"uploadImage"}>
                            <div style={{position: "relative", width: 56, height: 56, margin: "auto"}}>
                                <Upload
                                    name="file"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    beforeUpload={beforeUpload}
                                    customRequest={({file}) => {
                                        let url = "/storage/uploadFile";
                                        let fd = new FormData();
                                        fd.append("file", file);
                                        this.request({
                                            url,
                                            body: fd,
                                            method: "post",
                                            contentType: "upload",
                                            callBack: (fileInfo) => {
                                                let that = this;
                                                if (fileInfo) {
                                                    record.logo = fileInfo ? fileInfo.smallPath : null;
                                                    message.success("上传LOGO成功");
                                                    that.setState({
                                                        loading: false,
                                                    })
                                                } else {
                                                    message.error("上传LOGO失败");
                                                }
                                            },
                                            errorCallBack: () => {

                                            },
                                            serverVerify: {
                                                serverErrorCallBack: () => {

                                                }
                                            }
                                        });
                                    }}
                                >
                                    {record.logo ?
                                        <div><img src={record.logo} alt="avatar" style={{
                                            width: '46px',
                                            height: '46px',
                                            borderRadius: "50%",
                                            objectFit: 'cover'
                                        }}/></div> : uploadButton}
                                </Upload>
                                <Icon onClick={() => {
                                    record.logo = "";
                                    record.checked = false;
                                    this.setState({});
                                }} style={{
                                    position: "absolute",
                                    top: "-4px",
                                    right: "-7px",
                                    fontSize: "18px",
                                    display: record.logo ? "block" : "none"
                                }}
                                      type="close-circle" theme="filled"/>
                            </div>
                            <style>{`#uploadImage .ant-upload.ant-upload-select-picture-card{border-radius:50%;width:56px;height:56px;background:#F6F8FD;margin-right: 0;margin-bottom: 0;}
                            #uploadImage .ant-upload-picture-card-wrapper{display: flex;align-items: center;justify-content: center;}
                            #uploadImage .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                            `}</style>
                        </div>
                    )
                })
            },
            {
                title: <>{requiredMark()}主责单位</>,
                ellipsis: true,
                key: 'mainDeptName',
                width: 180,
                render: (record) => {
                    return (
                        <div>
                            <Select className={'mediaListContent'}
                                    placeholder={"主责单位"}
                                    value={record.mainDeptId}
                                    style={{width: '100%'}}
                                    onChange={(e) => {
                                        record.mainDeptId = e;
                                        this.setState({})
                                    }}>
                                {this.props.mainDutyDept && this.props.mainDutyDept.length > 0 && this.props.mainDutyDept.map(item => {
                                    return (
                                        <Option key={item.id}
                                                value={item.id}
                                        >
                                            {item.name}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </div>
                    )
                }
            },
            {
                title: '操作',
                ellipsis: true,
                key: 'operate',
                width: 180,
                render: (record => {
                    const text = '确认移除这行数据？';
                    let _this = this
                    function confirm() {
                        _this.deleteData(record);
                        message.destroy();
                        message.success('移除成功！');
                    }
                    return (
                        <div style={{alignItems: "center", color: "#0050B3", fontWeight: 400}}>
                            <span style={{cursor: "pointer"}} onClick={() => {
                                this.batchAddEdit(record)
                            }}>编辑</span>
                            <Popconfirm placement="right" title={text} onConfirm={confirm} okText="确定" cancelText="取消" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}>
                                 <span onClick={() => {
                                 }} style={{marginLeft: 15, cursor: "pointer", color: "red"}}>移除</span>
                            </Popconfirm>

                        </div>
                    )
                })
            },
        ];

    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.showCurrentPageType === "batchPage" && nextProps.batchAddData && nextProps.batchAddData.length > 0) {
            this.batchAdd.init({}, (batchAddButtons) => {
                this.setState({
                    batchAddButtons
                })
            })
        } else {
            this.setState({
                batchAddButtons: []
            })
        }
        if (nextProps.showCurrentPageType === "batchPage") {
            //把单个和批量导入的数据都让能显示维护字段值
            this.getNewExportData(nextProps.batchAddData, (exportData) => {
                this.state.dataSource = exportData;
            });
        }
        this.setState({}, () => {
            $('.ant-pagination-options-quick-jumper').find('input').val('')
        })
    }


    //验证媒体名称
    verifyName(record) {
        let body = {
            name: record.name,
            type: record.newMediaTypeId,
        };
        checkName(body, (data, status) => {
            if (data && status === 200) {
                let res = JSON.parse(data);
                Modal.success({
                    content: '媒体名称验证成功！',
                    centered: 'centered',
                    okText: "确定",
                    onOk: () => {
                        let mediaType = ["公众号", "微博"];
                        this.props.mediaPlatform.length && record.newMediaTypeId && this.props.mediaPlatform.filter(item => {
                            if (mediaType.indexOf(item.name) > -1 && item.id == record.newMediaTypeId) {
                                this.state.logo = item.logoPath;
                            }
                        });
                        record.ext && record.ext.length > 0 && record.ext.forEach(i => {
                            if (i.dbFieldName === "account") {
                                i.value = res.account;
                            }
                        })
                        record.name = res.nickname;
                        this.setState({name: res.nickname})
                    }
                });
            }
        }, {
            info: (info) => {
                Modal.warning({
                    content: '媒体名称验证失败！',
                    centered: 'centered',
                    okText: "确定",
                })
            }
        });
    }

    //验证抖音链接
    verifyLink() {
        let verifyParams = this.state.verifyParams;
        let name = verifyParams.name;
        let params = {
            link: this.state.link,
        };
        checkDouyinLink(params, (data, status) => {
            let res;
            if (data) {
                res = JSON.parse(data);
            }
            if ((name && name === res.nickname && status === 200)) {
                Modal.success({
                    content: '抖音链接验证成功！',
                    centered: 'centered',
                    okText: "确定",
                    onOk: () => {
                        let mediaType = ["抖音"];
                        this.props.mediaPlatform.length && verifyParams.newMediaTypeId && this.props.mediaPlatform.filter(item => {
                            if (mediaType.indexOf(item.name) > -1 && item.id == verifyParams.newMediaTypeId) {
                                this.state.logo = item.logoPath;
                            }
                        });
                        verifyParams.name = res.nickname;
                        verifyParams.ext && verifyParams.ext.length > 0 && verifyParams.ext.forEach(i => {
                            if (i.dbFieldName === "account") {
                                i.value = res.account;
                            }
                        })
                        this.setState({douYinVisible: false})
                    }
                });
            }
            if (!name) {
                if (status === 200) {
                    Modal.success({
                        content: '抖音链接验证成功！',
                        centered: 'centered',
                        okText: "确定",
                        onOk: () => {
                            let mediaType = ["抖音"];
                            this.props.mediaPlatform.length && verifyParams.newMediaTypeId && this.props.mediaPlatform.filter(item => {
                                if (mediaType.indexOf(item.name) > -1 && item.id == verifyParams.newMediaTypeId) {
                                    this.state.logo = item.logoPath;
                                }
                            });
                            verifyParams.name = res.nickname;
                            verifyParams.ext && verifyParams.ext.length > 0 && verifyParams.ext.forEach(i => {
                                if (i.dbFieldName === "account") {
                                    i.value = res.account;
                                }
                            })
                            this.setState({douYinVisible: false})
                        }
                    });
                }
            }
            if (name && status === 200 && name !== res.nickname) {
                Modal.confirm({
                    content: '抖音链接成功，检测到媒体名称与填写内容不一致，请问是否使用获取的名称？',
                    centered: 'centered',
                    okCancel: '取消',
                    okText: "确定",
                    onOk: () => {
                        let mediaType = ["抖音"];
                        this.props.mediaPlatform.length && verifyParams.newMediaTypeId && this.props.mediaPlatform.filter(item => {
                            if (mediaType.indexOf(item.name) > -1 && item.id == verifyParams.newMediaTypeId) {
                                this.state.logo = item.logoPath;
                            }
                        });
                        verifyParams.name = res.nickname;
                        verifyParams.ext && verifyParams.ext.length > 0 && verifyParams.ext.forEach(i => {
                            if (i.dbFieldName === "account") {
                                i.value = res.account;
                            }
                        })
                        this.setState({douYinVisible: false})
                    }
                })
            }

        }, {
            info: (info) => {
                Modal.warning({
                    content: '请检查链接是否正确',
                    centered: 'centered',
                    okText: "确定",
                });
                this.setState({douYinVisible: false});
            },
            error: (error) => {

            }
        });
    }


    //获取抖音链接方式
    getLink() {
        window.openPage({
            url: "/cm-sites/pms/framereact/index.html#/view/newMediaMatrix/pms/newMediaManagement/douYinLink",
            params: {},
        })
    }

    //批量新增编辑
    batchAddEdit(record) {
        this.batchAdd.openModal();
        this.setState({
            currentMedia: record,
            simpleAddOrEdit: true,
        }, () => this.batchAdd.init(record));
    }

    //批量新增添加
    batchNewAdd() {
        this.batchAdd.openModal();
        this.batchAdd.revert();
        this.setState({simpleAddOrEdit: true}, () => this.batchAdd.init({}))
    }

    //移除接口
    deleteData(record) {
        let body = {
            newMediaIds: record.id,
        };
        deleteData(body, (data) => {
            if (data) {
                message.success("移除成功");
                this.setState({
                    saveAfterExit: true
                })
            } else {
                message.error("移除失败");
            }
            this.props.getTempBatchAdd();
        })
    }

    //新增账号上传账号头像
    accountAvatarChange(info, record) {
        console.log(info)
        if (info.file.status === 'uploading') {
            record.checked = true;   //单个上传加载显示
            this.setState({})
            return;
        }
        if (info.file.status === 'done') {
            let fileInfo = info.file.response;
            record.logo = fileInfo ? fileInfo.url : null;
            this.setState({});
        }
    };

    getNewExportData(exportData, callback) {
        console.log(exportData)
        exportData.forEach(item => {
            if (!item.ext.length) {
                getNewMediaFields({newMediaTypeId: item.newMediaTypeId}, (data) => {
                    console.log(data)
                    data && data.length && data.forEach(i => {
                        if (item[i.dbFieldName]) {
                            i.value = item[i.dbFieldName];
                        }
                    })
                    item.ext = data;
                })
            }
            item.logo = this.props.mediaPlatform.length && this.props.mediaPlatform.find(i => i.id === item.newMediaTypeId).logoPath
        })
        callback(exportData);
    }

    render() {
        const menu = <Menu id={"mediaManageMenu"}>
            <Menu.Item>
                <Upload accept={".xlsx,.xls"}
                        showUploadList={false}
                        beforeUpload={(file) => {
                            let type;
                            if (file) {
                                let index = file.name.lastIndexOf(".");
                                type = file.name.slice(index);
                            }
                            const isJpgOrPng = type === '.xlsx' || type === '.xls';
                            if (!isJpgOrPng) {
                                message.error('仅支持上传xlsx、xls文件！');
                            }
                            const isLt2M = file.size / 1024 / 1024 < 100;
                            if (!isLt2M) {
                                message.error('文件必须小于100M！');
                            }
                            return isJpgOrPng && isLt2M;
                        }}
                        customRequest={({file}) => {
                            let url = "/newmedia-business-server/fileHandler/batchImportVerify";
                            let fd = new FormData();
                            fd.append("file", file);
                            this.request({
                                url, body: fd, method: "post", contentType: "upload", callBack: (data) => {
                                    let that = this;
                                    if (data) {
                                        message.success("批量导入成功");
                                        console.log(JSON.parse(data))
                                        let exportData = JSON.parse(data);
                                        if (exportData.data.length > 0) {
                                            this.props.getTempBatchAdd();  //刷新暂存列表
                                            that.setState({
                                                simpleAddOrEdit: false,
                                                saveAfterExit: true
                                            }, () => this.batchAdd.init({}, (batchAddButtons) => {
                                                that.setState({
                                                    batchAddButtons
                                                })
                                            }))
                                        }
                                    } else {
                                        message.error("批量导入失败");
                                    }
                                }, errorCallBack: () => {

                                }, serverVerify: {
                                    serverErrorCallBack: () => {

                                    }
                                }
                            });
                        }}
                >
                    批量导入
                </Upload>
            </Menu.Item>
            <style>{`
            #mediaManageMenu .ant-dropdown-menu-item{padding: 5px 0px;}
            #mediaManageMenu .ant-upload.ant-upload-select>span{display: inline-block;width: 100px;padding-left: 10px;}
            `}</style>
            <Menu.Item onClick={() => {
                this.downLoadTemplate()
            }}><span style={{paddingLeft: 10}}>下载模板</span></Menu.Item>
        </Menu>
        let height = window.innerHeight - 385;
        return (
            <div id={"batchTable"}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "24px 24px 0px",
                    backgroundColor: "#fff"
                }}>
                    <div>{this.renderDouYin()}</div>
                    <div id={"mediaAdministerDropdownBtn"}>
                        <Dropdown overlay={menu} placement="bottomLeft">
                            <ButtonGroup>
                                <Button type={"primary"}>批量导入</Button>
                                <Button type={"primary"} icon="ellipsis"/>
                            </ButtonGroup>
                        </Dropdown>
                    </div>
                    <style>{`#mediaAdministerDropdownBtn .ant-btn.ant-btn-primary.ant-btn-icon-only{padding: 0px 10px 0px 0px;}
                    #mediaAdministerDropdownBtn .ant-btn.ant-btn-primary{padding: 0px 0px 0px 10px;}
                    `}</style>
                </div>
                <div style={{backgroundColor: "#fff", padding: "24px"}}>
                    <Scrollbars autoHeight autoHeightMax={height}>
                        <Table
                            rowKey={record=>record.id}
                            columns={this.batchAddColumns}
                            pagination={false}
                            dataSource={this.state.dataSource}
                        />
                        <style>{`
                    #batchTable .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #batchTable .ant-table-placeholder{border-bottom: 0;}
                `}</style>
                    </Scrollbars>
                    {/*渲染添加按钮*/}
                    <div onClick={() => {
                        this.batchNewAdd()
                    }} style={{
                        cursor: "pointer",
                        textAlign: "center",
                        width: "100%",
                        height: "40px",
                        lineHeight: "40px",
                        border: "1px dashed #D9D9D9",
                        marginTop: 12
                    }}>
                        <Icon type="plus" style={{marginRight: "5px"}}/>添加
                    </div>
                </div>
                <Divider style={{display: this.state.dataSource.length ? "block" : "none"}}/>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "0px 0px 5px 5px"
                }}>
                    {
                        this.state.dataSource && this.state.dataSource.length > 0 ? this.state.batchAddButtons : null
                    }
                </div>
                {/*媒体信息组件*/}
                <NewAddMedia
                    currentMedia={this.state.currentMedia}
                    mainDutyDept={this.props.mainDutyDept}
                    mediaPlatform={this.props.mediaPlatform}
                    onRef={(c) => this.batchAdd = c}
                    batchData={this.state.dataSource}
                    showCurrentPageType={this.props.showCurrentPageType}
                    batchTitle={this.props.batchTitle}
                    simpleAddOrEdit={this.state.simpleAddOrEdit}
                    goBack={() => this.props.goBack()}
                    simpleAddOrEditChange={() => {
                        this.setState({
                            simpleAddOrEdit: false
                        })
                    }}
                    getTempBatchAdd={() => this.props.getTempBatchAdd()}
                    cancelExport={() => this.props.cancelExport()}
                    saveAfterExitChange={() => {
                        this.setState({
                            saveAfterExit: true
                        })
                    }}
                    batchSaveAfterEdit={() => {
                        this.setState({
                            saveAfterExit: false
                        })
                    }}
                />
            </div>
        )
    }


    //渲染抖音链接弹窗
    renderDouYin() {
        return (
            <div>
                <Modal title='验证'
                       visible={this.state.douYinVisible}
                       centered={true}
                       width={500}
                       maskClosable={false}
                       onOk={() => this.verifyLink()}
                       onCancel={() => this.setState({douYinVisible: false})}
                       footer={
                           <div style={{textAlign: 'center'}}>
                               <Button style={{marginRight: 20}}
                                       onClick={() => this.setState({douYinVisible: false})}>取消</Button>
                               <Button type="primary" onClick={() => this.verifyLink()}>验证</Button>
                           </div>
                       }
                >
                    <Form.Item label="抖音链接" labelCol={{span: 5}} wrapperCol={{span: 10}}>
                        <div style={{width: 350}}>{this.state.link}</div>
                        <div style={{cursor: "pointer", color: "#0050B3", fontsize: "10px"}}
                             onClick={() => this.getLink()}>链接如何获取
                        </div>
                    </Form.Item>
                </Modal>
            </div>
        )
    }

    //获取导入模板
    downLoadTemplate() {
        window.loading.show();
        getExcelTemplate({}, (data) => {
            window.loading.hide();
        }, {
            error: (error) => {
                message.error(error);
            }
        })
    }


    //导入模板
    saveExcelTemplate(data) {
        let body = {
            name: data.name,
            path: data.path,
            size: data.size,
            suffix: data.suffix,
            uploadTime: data.createTime,
            uploadUserName: window.top.currentUser.userName,
        };
        saveExcelTemplate(body, (data) => {
            console.log(data)
        })
    }


}


function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/bmp' || file.type === 'image/png' || file.type === 'image/gif';
    // let reg=/^{1,100}$/;
    let fileName = file.name;
    if (fileName.length > 100) {
        message.error('图片名称不能超过100个字符');
    }
    if (!isJpgOrPng) {
        message.error('只能上传JPG、jpeg、bmp、png、gif文件！');
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.error('图片大小必须小于20MB!');
    }
    return isJpgOrPng && isLt2M && fileName;
}
